<template>
	<div>
		<div class="form-group">
			<ejs-combobox v-model="reports" :select='select' :dataSource='dataSourceReports' :fields='fieldsSourceProceso' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textReports.textFormSelectReport')"></ejs-combobox>
		</div>
		<component v-bind:is="reports" :tittle="reportTittle"></component>
	</div>
</template>

<script>
import axios from 'axios'
import { ComboBoxPlugin } from '@syncfusion/ej2-vue-dropdowns';
Vue.use(ComboBoxPlugin);
export default {
	name: "reports-index",
	data(){
		return {
			reports : '',
			reportTittle : '',
			dataSourceReports: [
				{ value: 'reports-form-user-access', text: "Accesos de usuario"},
				{ value: 'reports-form-accomplishment', text: "Cumplimientos"},
				{ value: 'reports-form-homework', text: "Deberes"},
				{ value: 'reports-form-regulatory-update', text: "Actualizaciones normativas"},
				{ value: 'reports-form-processes', text: "Asuntos/Procesos"},
				{ value: 'reports-form-processes-details', text: "Detalles procesos"},
			],
			fieldsSourceProceso: { text: "text", value: 'value' },
		}
	},
	methods: {
		select: function(args) {
			this.reportTittle = args.itemData.text;
      }
	},
	mounted() {
		let user = this.$store.getters["moduleAvatar/avatar"];
		if(parseInt(user.perfil_id) === 8 || parseInt(user.perfil_id) === 9){
			this.dataSourceReports.push({ value: 'reports-form-processes-compliance', text: "Asociación Procesos - Asuntos Normativos"});
		}
	},
}
</script>
